export default __webpack_public_path__ + "static/facebook-colored-6cb0fe72d664a0425008fdf886db59d6.svg";